import React from 'react';
import styled from 'styled-components';
import BannerImgGameZone from '../assetts/images/pricelist.jpg';

const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 15px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  margin: 20px auto;

  @media (max-width: 768px) {
    padding: 15px;
    max-width: 100%;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
  object-fit: cover;

  @media (max-width: 768px) {
    border-radius: 8px;
  }
`;

const BanerImg = () => {
  return (
    <BannerContainer>
      <StyledImage src={BannerImgGameZone} alt="baner" />
    </BannerContainer>
  );
};

export default BanerImg;
